module.exports = __webpack_public_path__ + "static/media/Coda Group_Logotyp-06.5d79b94d.png";